/*
 * @Description:
 * @Author: dandan.Wu
 * @Date: 2021-01-19 09:54:36
 * @LastEditTime: 2023-11-27 15:28:58
 * @LastEditors: dandan.Wu
 */
export const applyForm: ApplyTypes.ApplyForm = {
  uuid: '',
  phone: '',
  intro: '',
  userWork: '',
  certificateType: '0',
  certificateId: '',
  certificateImg: '',
}

export const certificationForm: ApplyTypes.CertificationForm = {
  uuid: '',
  actualName: '', // 姓名
  certificateType: '0', // 证件类型
  idCardNumber: '', // 证件号码
  idCardFront: '', // 证明照片 正面
  idCardRear: '', // 证明照片 反面
  bankCard: '', // 银行卡号
  mobile: '', // 电话号码
}

export const userInfoForm: ApplyTypes.UserInfoForm = {
  uuid: '', //用户uuid
  ticket: '', //用户登陆ticket
  nickname: '', //昵称
  avatar: '', //头像
  accountType: 1, //账户类型
  introduction: '', //简介
  // invitationCode: '', //邀请码
}

// 个人申请的状态
export const CHECK_STATUS = {
  // NOT_APPLY: -1, // 自定义未申请的状态值
  // AUDITINT: 0, // 审核中
  // GETTED: 1, // 申请成功
  // INFO_GET: 2, // 审核不通过
  // CANCEL: 3, // 资格被取消
  // NOVERIFI: 4, // 已实名未入驻
  // SETNOVERIFI: 5, // 已入驻未实名

  NOT_APPLY: -1, // 自定义未申请的状态值
  AUDITINT: 1, // 审核中
  GETTED: 2, // 申请成功
  INFO_GET: 3, // 审核不通过
  CANCEL: 4, // 资格被取消
  ISPARTNER: 5, // 表示分账剧认证状态 已通过
  // NOVERIFI: 4, // 已实名未入驻
  // SETNOVERIFI: 5, // 已入驻未实名
}
